module.exports = __webpack_public_path__ + "img/icon.fa1d4b9e.png";